import React from 'react'
import PropTypes from 'prop-types'
import { Repeat } from 'immutable'

import { PureDataComponent } from '@aytm/lib/common/components/pure-component'

import '@aytm/lib/rfd-ui/styles/basic/loader-wave.scss'

export default class LoaderWave extends PureDataComponent {
  static propTypes = {
    bars: PropTypes.number,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }

  render() {
    const bars = this.props.bars || 20
    const height = this.props.height || 12
    return (
      <span className="rfd-ui-loader-wave" style={{ height }}>
        {Repeat(null, bars)
          .map((_v, i) => <span key={i} className={`rfd-ui-loader-wave-bar rfd-ui-loader-wave-bar-${i % 50}`} />)
          .toArray()}
      </span>
    )
  }
}
